import { render, staticRenderFns } from "./AccountReset.vue?vue&type=template&id=585e0773&"
import script from "./AccountReset.vue?vue&type=script&lang=js&"
export * from "./AccountReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports